<template>
    <div class="grid">
        <div class="unit whole">
            <h1>Reporting</h1>
            <p class="lead">See RTQ results at class or pupil level.</p>
        </div>
    </div>
    <ReportingOverviewComp :pupils="pupils" :classes="classes" />
    <v-overlay :model-value="!(isLoaded.pupils || isLoaded.classes)" class="align-center justify-center">
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';

definePage({ meta: { area: 'reporting' } });

const store = useAdminStore();
store.fetchPupils();
store.fetchClasses();

const { pupils, classes, isLoaded } = storeToRefs(store);
</script>
